import { always } from 'ramda'
import { createReducer } from '../../utilities/miscellaneous'

const INITIAL_TOP_ARTICLES_STATE = {
  list: [],
  isFetching: true,
  limit: 6,
}

const INITIAL_I24NEWS_PLUS_VIDEOS_STATE = {
  list: [],
  isFetching: true,
  limit: 8,
  error: false,
}

export const INITIAL_STATE = {
  topArticles: INITIAL_TOP_ARTICLES_STATE,
  i24NewsPlusVideos: INITIAL_I24NEWS_PLUS_VIDEOS_STATE,
}

export const FETCH_TOP_ARTICLES = 'homepage/FETCH_TOP_ARTICLES'
export const RECEIVED_TOP_ARTICLES = 'homepage/RECEIVED_TOP_ARTICLES'
export const CLEAN_TOP_ARTICLES = 'homepage/CLEAN_TOP_ARTICLES'

export const FETCH_I24NEWS_PLUS_VIDEOS = 'homepage/FETCH_I24NEWS_PLUS_VIDEOS'
export const I24NEWS_PLUS_VIDEOS_RECEIVED = 'homepage/I24NEWS_PLUS_VIDEOS_RECEIVED'
export const I24NEWS_PLUS_VIDEOS_ERROR = 'homepage/I24NEWS_PLUS_VIDEOS_ERROR'
export const CLEAN_I24NEWS_PLUS_VIDEOS = 'homepage/CLEAN_I24NEWS_PLUS_VIDEOS'

// fetchTopArticles :: () -> Action.FETCH_TOP_ARTICLES
export const fetchTopArticles = always({ type: FETCH_TOP_ARTICLES })

// receivedTopArticles :: [Object] -> Action.RECEIVED_TOP_ARTICLES
export const receivedTopArticles = articles => ({
  type: RECEIVED_TOP_ARTICLES,
  articles,
})

// cleanTopArticles :: () -> Action.CLEAN_TOP_ARTICLES
export const cleanTopArticles = always({ type: CLEAN_TOP_ARTICLES })

// fetchI24NewsPlusVideos :: () -> Action.FETCH_I24NEWS_PLUS_VIDEOS
export const fetchI24NewsPlusVideos = always({ type: FETCH_I24NEWS_PLUS_VIDEOS })

// i24NewsPlusVideosReceived :: [Object] -> Action.I24NEWS_PLUS_VIDEOS_RECEIVED
export const i24NewsPlusVideosReceived = videos => ({
  type: I24NEWS_PLUS_VIDEOS_RECEIVED,
  videos,
})

// i24NewsPlusVideosError :: () -> Action.I24NEWS_PLUS_VIDEOS_ERROR
export const i24NewsPlusVideosError = always({ type: I24NEWS_PLUS_VIDEOS_ERROR })

// cleanI24NewsPlusVideos :: () -> Action.CLEAN_I24NEWS_PLUS_VIDEOS
export const cleanI24NewsPlusVideos = always({ type: CLEAN_I24NEWS_PLUS_VIDEOS })

export default createReducer(INITIAL_STATE, {
  [FETCH_TOP_ARTICLES]: state => ({
    ...state,
    topArticles: {
      ...state.topArticles,
      isFetching: true,
    },
  }),

  [RECEIVED_TOP_ARTICLES]: (state, { articles }) => ({
    ...state,
    topArticles: {
      ...state.topArticles,
      list: articles,
      isFetching: false,
    },
  }),

  [CLEAN_TOP_ARTICLES]: state => ({
    ...state,
    topArticles: INITIAL_TOP_ARTICLES_STATE,
  }),

  [FETCH_I24NEWS_PLUS_VIDEOS]: state => ({
    ...state,
    i24NewsPlusVideos: {
      ...state.i24NewsPlusVideos,
      isFetching: true,
    },
  }),

  [I24NEWS_PLUS_VIDEOS_RECEIVED]: (state, { videos }) => ({
    ...state,
    i24NewsPlusVideos: {
      ...state.i24NewsPlusVideos,
      list: videos,
      isFetching: false,
      error: false,
    },
  }),

  [I24NEWS_PLUS_VIDEOS_ERROR]: state => ({
    ...state,
    i24NewsPlusVideos: {
      ...state.i24NewsPlusVideos,
      error: true,
      isFetching: false,
    },
  }),

  [CLEAN_I24NEWS_PLUS_VIDEOS]: state => ({
    ...state,
    i24NewsPlusVideos: INITIAL_I24NEWS_PLUS_VIDEOS_STATE,
  }),
})
